import React, { useState } from 'react'
import { Box, Icon, Typography } from '@mui/material'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import AdxInput from 'components/custom/AdxInput'
import { Link } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'

const ACNonCustomEvaluationList = ({
  id,
  title,
  rightComponent,
  handleRemoveNonCustom,
  external,
  updateMutate,
  weightage,
}) => {
  const [selectValue, setSelectValue] = useState(weightage)

  const handleChange = (e) => {
    setSelectValue(e.target.value)
  }

  const handleUpdate = (e) => {
    updateMutate({ evaluationId: e.target.name, data: { weightage: +selectValue, title: title } })
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        columnGap={2}
        padding={2}
        sx={{
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
        }}
      >
        <Box sx={{ width: '52%', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body1" color="dark-text.main">
            {title}
          </Typography>
          {external && (
            <AdxStatusBar
              status={{
                text: 'External',
                color: 'alternate.main',
                bgColor: 'alternate.light',
              }}
            />
          )}
        </Box>
        <Box
          sx={{
            width: '20%',
            display: 'flex',
            justifyContent: 'center',
          }}
          disabled
        >
          <Link
            to={`/app/management-centre/company-management/appraisal/evaluation/preview/${id}`}
            target="_blank"
            style={{
              textDecoration: 'none',
              color: !external ? 'white' : 'gray',
              pointerEvents: !external ? 'pointer' : 'none',
            }}
          >
            <AdxButton variant={'contained'} size="standard" disabled={!external ? false : true}>
              Preview
            </AdxButton>
          </Link>
        </Box>
        <AdxInput
          value={selectValue}
          onChange={handleChange}
          onBlur={handleUpdate}
          placeholder="0"
          sx={{ width: '20%' }}
          name={id.toString()}
        />
        <Box display="flex" alignItems="center" justifyContent="space-between" width="8%">
          {rightComponent ? (
            rightComponent
          ) : (
            <>
              <Icon
                onClick={() => handleRemoveNonCustom(id)}
                sx={{
                  color: 'error.main',
                  cursor: 'pointer',
                }}
              >
                remove_circle
              </Icon>
            </>
          )}
        </Box>
      </Box>
    </>
  )
}

export default ACNonCustomEvaluationList
